import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

interface BasicMenuProps {
	title: any;
	options: { label: string; onClick: () => void }[];
}

export default function BasicMenu({ title, options }: BasicMenuProps) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<Button className="menu-icon" id="basic-button" aria-controls={open ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} onClick={handleClick}>
				{title}
			</Button>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
			>
				{options.map((option) => (
					<MenuItem
						key={option.label}
						onClick={() => {
							option?.onClick?.();
							handleClose();
						}}
					>
						{option.label}
					</MenuItem>
				))}
				{/* <MenuItem onClick={handleClose}>Logout</MenuItem> */}
			</Menu>
		</div>
	);
}
